import ActionsComponent from "../categories/actions";
export default ActionsComponent